import React from 'react'

import { WHITE_COLOR } from '../../constants'

const defaultProps = {
  fill: WHITE_COLOR,
  width: 24,
  height: 24,
}

const IconNotConfirmed = (props) => {
  let circleStroke = props.circleStroke
  if (!props.enableOutline) {
    circleStroke = props.fill
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width}
      height={props.height}
      viewBox="180 -859 600 758"
      fill={props.fill}
    >
      <path d="M500.82-350.8q8.51-8.64 8.51-20.82t-8.51-20.82q-8.51-8.64-20.82-8.64t-20.82 8.64q-8.51 8.64-8.51 20.82t8.51 20.82q8.51 8.65 20.82 8.65t20.82-8.65Zm-45.95-114.79h50.26v-196.72h-50.26v196.72ZM480-101.18q-130.18-35.64-215.09-154.39Q180-374.31 180-519.38v-227.18l300-112.31 300 112.31v227.18q0 145.07-84.91 263.81Q610.18-136.82 480-101.18Zm0-52.67q109.28-35.3 179.51-137.48 70.23-102.18 70.23-228.05v-192.39L480-805.44l-249.74 93.67v192.39q0 125.87 70.23 228.05T480-153.85Zm0-325.77Z" />
    </svg>
  )
}

IconNotConfirmed.defaultProps = defaultProps

export default IconNotConfirmed
